// assets
import OrgIcon from '../assets/static_images/org.svg';

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

// Function to check if user is admin
const isAdmin = () => {
    try {
        const authUser = JSON.parse(window.localStorage.getItem('authUser'));
        // Check if user is admin (role_id === 1 is super admin, is_admin === true is admin)
        return authUser?.role_id === 1 || authUser?.is_admin === true;
    } catch (error) {
        return false;
    }
};

// Default menu items - everyone gets selfAnalytics
const defaultChildren = [
    {
        id: 'selfAnalytics',
        title: 'Self Analytics',
        type: 'item',
        url: '/self-analytics',
        breadcrumbs: false
    }
];

// Admin-only menu items
const adminChildren = [
    {
        id: 'departmentAnalytics',
        title: 'Department Analytics',
        type: 'item',
        url: '/department-analytics',
        breadcrumbs: false
    },
    {
        id: 'divisionAnalytics',
        title: 'Division Analytics',
        type: 'item',
        url: '/division-analytics',
        breadcrumbs: false
    },
    {
        id: 'organizationAnalytics',
        title: 'Organization Analytics',
        type: 'item',
        url: '/organization-analytics',
        breadcrumbs: false
    }
];

// Get children based on user role
const getChildren = () => {
    if (isAdmin()) {
        return [...defaultChildren, ...adminChildren];
    }
    return defaultChildren;
};

const Analytics = {
    id: `analyticsTab`,
    title: 'Analytics',
    type: 'group',
    icon: OrgIcon,
    children: getChildren()
};

export default Analytics;
